import React, { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import "./index.scss";
import { useTranslation } from "react-i18next";
import { useSelector } from "react-redux";
import { useGetTrendingQuery, useGetPopularQuery } from "../../services/homepage";
import ImageList from "@material-ui/core/ImageList";
import ImageListItem from "@material-ui/core/ImageListItem";
import { makeStyles } from "@material-ui/core/styles";
import HomeData from "../../Components/HomeData";
import "react-lazy-load-image-component/src/effects/blur.css";
import HomeCarousel from "../../Components/HomeCarousel";
import HomeProductCards from "../../Components/HomeProductCards";
import HelmetComponent from "../../Components/HelmetComponent";
import { getMetaByCountry } from "../../metaConfig";

const useStyles = makeStyles((theme) => ({
  root: {
    display: "flex",
    flexWrap: "wrap",
    justifyContent: "space-around",
    overflow: "hidden",
  },
  imageList: {
    "&::-webkit-scrollbar": {
      display: "none",
    },
    flexWrap: "nowrap",
    transform: "translateZ(0)",
  },
  title: {
    color: theme.palette.primary.light,
  },
  titleBar: {
    background: "linear-gradient(to top, rgba(0,0,0,0.7) 0%, rgba(0,0,0,0.3) 70%, rgba(0,0,0,0) 100%)",
  },
}));

function Home() {
  const { t } = useTranslation();
  const { countryCode } = useSelector((state) => state.auth);
  const trendingData = useGetTrendingQuery(
    { countryCode: countryCode },
    { count: 1 },
    { refetchOnMountOrArgChange: true }
  );
  const popularData = useGetPopularQuery(
    { countryCode: countryCode },
    { count: 1 },
    { refetchOnMountOrArgChange: true }
  );

  useEffect(() => {
    window.scrollTo({
      top: 0,
      left: 0,
      // behavior: "smooth"
    });
  }, []);

  const classes = useStyles();
  let adcPosition;
  if (document.body.dir === "rtl") {
    adcPosition = { left: "10px" };
  } else {
    adcPosition = { right: "10px" };
  }

  function bannerCategories() {
    return (
      <div className="container">
        <ImageList className={classes.imageList} cols={8}>
          {HomeData?.category_a?.map((item, i) => (
            <ImageListItem className="cardItem" key={i}>
              <Link to={`/search/${item.link}`} className="cardItem-item" style={{ border: "none" }}>
                <div className="img-card categories-card" style={{ height: "auto" }}>
                  <img
                    style={{ padding: "0px", borderRadius: "8px", height: "auto" }}
                    className="img-item"
                    src={item?.image}
                    alt={item?.name}
                  />
                </div>
              </Link>
              {item.name && (
                <div className="card-content" style={{ height: "auto", whiteSpace: "nowrap" }}>
                  <h4>{t(item.name)}</h4>
                </div>
              )}
            </ImageListItem>
          ))}
        </ImageList>
      </div>
    );
  }

  const [isMetaTitle, setMetaTitle] = useState("");
  const [isMetaDescription, setMetaDescription] = useState("");
  useEffect(() => {
    const { title, description } = getMetaByCountry(countryCode);
    setMetaTitle(title);
    setMetaDescription(description);
  }, [countryCode]);

  return (
    <>
      <HelmetComponent title={""} metaTitle={isMetaTitle} metaDescription={isMetaDescription} />
      <div className="hp-style">
        <HomeCarousel />

        <div className="container">
          <br />
          <ImageList className={classes.imageList} cols={5}>
            {HomeData?.fashion?.map((item, i) => (
              <ImageListItem className="cardItem" key={i}>
                <Link to={`/search/${item.link}`} className="cardItem-item" style={{ border: "none" }}>
                  <div className="img-card">
                    <img
                      style={{ padding: "0px", borderRadius: "8px", height: "auto" }}
                      className="img-item"
                      src={item?.image}
                      alt={item?.name}
                    />
                  </div>
                </Link>
                {item.name && (
                  <div className="card-content" style={{ height: "auto" }}>
                    <h4>{t(item.name)}</h4>
                  </div>
                )}
              </ImageListItem>
            ))}
          </ImageList>
          <br />

          <br />
          <HomeProductCards
            productData={trendingData.data?.trendings}
            isLoading={trendingData?.isLoading}
            heading={t("INTERNATIONAL BESTSELLERS")}
          />
          <br />
          <div className="cardTitle">Category Speed Dial</div>
          <ImageList className={classes.imageList} cols={6}>
            {HomeData?.category_b?.map((item, i) => (
              <ImageListItem className="cardItem" key={i}>
                <Link to={`/search/${item.link}`} className="cardItem-item" style={{ border: "none" }}>
                  <div className="img-card">
                    <img
                      style={{ padding: "0px", borderRadius: "8px", height: "auto" }}
                      className="img-item"
                      src={item?.image}
                      alt={item?.name}
                    />
                  </div>
                </Link>
                {/* {item.name && (
                  <div className="card-content" style={{ height: "auto" }}>
                    <h4>{t(item.name)}</h4>
                  </div>
                )} */}
              </ImageListItem>
            ))}
          </ImageList>
          <br />
          <HomeProductCards
            productData={popularData.data?.popular}
            isLoading={popularData?.isLoading}
            heading={t("popular products")}
          />
          <br />

          <a
            className="social-promo"
            href="https://www.instagram.com/theglobalgenie/?hl=en"
            target="_blank"
            rel="noreferrer"
          >
            <div className="social-promo-inner">
              <button className="social-promo-explore">Explore Now</button>
              <img
                className="social-promo-img"
                src="https://d1006gs7mu1yt6.cloudfront.net/task/3/22/1769523847112-9883125_upscayl_4x_upscayl-standard-4x.png"
                alt="Social media preview"
              />
              <button className="social-promo-follow">Follow Us</button>
            </div>
          </a>

          <div style={{ margin: "50px 0px", borderTop: "1px solid #eee", borderBottom: "1px solid #eee" }}>
            {/* <img
              style={{ width: "100%" }}
              src="https://cdn.ebtida.com/1762252133365-web-page.3_upscayl_4x_upscayl-standard-4x_d8b114f8-de33-498e-8916-7279a070624f.webp"
            /> */}
            <br />
            <br />

            <ImageList className={classes.imageList} style={{ justifyContent: "center" }} cols={4}>
              <ImageListItem className="cardItem">
                <div className="img-card">
                  <img style={{ width: "80px" }} src="https://cdn.ebtida.com/1769542475311-support-services.png" />
                </div>

                <div className="card-content" style={{ height: "auto", textAlign: "center" }}>
                  <h4 style={{ fontSize: "1.2rem" }}>Heart Winning Customer Service</h4>
                </div>
              </ImageListItem>

              <ImageListItem className="cardItem">
                <div className="img-card">
                  <img style={{ width: "80px" }} src="https://cdn.ebtida.com/1769542480554-return.png" />
                </div>

                <div className="card-content" style={{ height: "auto", textAlign: "center" }}>
                  <h4 style={{ fontSize: "1.2rem" }}>Free and Easy Returns</h4>
                </div>
              </ImageListItem>

              {countryCode === "IN" && (
                <ImageListItem className="cardItem">
                  <div className="img-card">
                    <img style={{ width: "80px" }} src="https://cdn.ebtida.com/1769542485292-truck.png" />
                  </div>

                  <div className="card-content" style={{ height: "auto", textAlign: "center" }}>
                    <h4 style={{ fontSize: "1.2rem" }}>Free Shipping Pan India</h4>
                  </div>
                </ImageListItem>
              )}
              <ImageListItem className="cardItem">
                <div className="img-card">
                  <img style={{ width: "80px" }} src="https://cdn.ebtida.com/1769542490024-credit-card.png" />
                </div>

                <div className="card-content" style={{ height: "auto", textAlign: "center" }}>
                  <h4 style={{ fontSize: "1.2rem" }}>Super Secure Payment</h4>
                </div>
              </ImageListItem>
            </ImageList>
            <br />
            <br />
          </div>
        </div>
        <br />

        {/* <div className="container">
          <div style={{ textAlign: "center", margin: "20px 0px" }}>
            <div className="cardTitle">The Global Genie – Bringing Top USA Brands to Your Doorstep in India</div>
            <div>
              <p>
                At The Global Genie, we offer a wide range of premium products imported directly from the USA to India.
                Whether you're looking for Health and Personal Care, Beauty and Cosmetics, Baby & Mom Essentials,
                Lifestyle, Gadgets and the comfort of your home.
              </p>
              <p>
                Our curated collection features top-tier products that are carefully sourced from the USA, ensuring
                quality and reliability. From skincare products to innovative gadgets, we bring you the latest and most
                trusted brands, all while providing fast and free shipping with no hidden costs. At The Global Genie, we
                believe in a seamless shopping experience that’s hassle-free and transparent.
              </p>
              <p>
                Can't find what you're looking for? No problem! Our GET ME THIS feature allows you to submit your
                product requests. Simply post your requirement, and we will go the extra mile to bring the product
                directly from the USA to you in India. It’s that easy.
              </p>
              <p>
                Enjoy the convenience of global shopping, knowing that your products will arrive quickly, securely, and
                without any surprise charges. Whether you’re treating yourself, shopping for your family, or pampering
                your pet, The Global Genie has something for everyone.
              </p>
              <p>Explore our website today and bring the best of the USA to your doorstep. Happy shopping.</p>
            </div>
          </div>
          <br />
        </div> */}
      </div>
    </>
  );
}

export default Home;
